/* Tavilume lighting-option display normalizer — display text only. */
(() => {
  const normalizeValue = (value) => String(value || '')
    .replaceAll(
      '3000K 3000K Warm White · Fixed Brightness · 3-Step Brightness',
      '3000K Warm White · 3-Step Brightness'
    )
    .replaceAll('Three-Color Changing Light', '3-CCT Selectable · Fixed Brightness')
    .replaceAll('Three-color changing light', '3-CCT Selectable · Fixed Brightness');

  const normalizeTextNodes = (element, includeName = false) => {
    element.childNodes.forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) return;
      let next = normalizeValue(node.textContent);
      if (includeName) next = next.replace(/Light Color/gi, 'Lighting Configuration');
      if (next !== node.textContent) node.textContent = next;
    });
  };

  const normalizeLightingOptions = (root = document) => {
    root.querySelectorAll(
      '.variant-option__button-label__text, [data-testid="variant-option-single-value"], .variant-option__select-wrapper option'
    ).forEach((element) => normalizeTextNodes(element));
    root.querySelectorAll('variant-picker legend, [data-testid="variant-option-single"]').forEach(
      (element) => normalizeTextNodes(element, true)
    );
  };

  const bootLightingNormalizer = () => {
    normalizeLightingOptions();
    document.querySelectorAll('variant-picker').forEach((picker) => {
      new MutationObserver(() => normalizeLightingOptions(picker)).observe(picker, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLightingNormalizer, { once: true });
  } else {
    bootLightingNormalizer();
  }
})();
